import { shoppingCartAPI } from "services/swagger-api";
import { MainBorrowerPricingSyncActions } from "../types";

export const deleteBorrowerCartItem = async (
  borrowerProjectId: string,
  hash: string,
  actions: MainBorrowerPricingSyncActions) => {
  actions.setLoading(true)
  try {
    const response = await shoppingCartAPI.removeBorrowerCartItem({ hash, borrowerProjectId })
    if (response.isSuccess) {
      // Refetch le panier complet pour synchroniser le state
      const cart = await shoppingCartAPI.fetchBorrowerShoppingCart({ borrowerProjectId })
      actions.updateShoppingCart(cart.items ?? [])
    }
  } catch (error) {
    console.log(error)
  } finally {
    actions.setLoading(false)
  }
}
